var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDebug(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m56 19v27h-48v-27c0-1.1.9-2 2-2h44c1.1 0 2 .9 2 2z",
    fill: "#0a5078"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m53.82 46h-5.64l-7.81-7.8c-2.33 1.75-5.23 2.8-8.37 2.8-7.73 0-14-6.27-14-14 0-3.92 1.61-7.46 4.21-10h19.58c2.6 2.54 4.21 6.08 4.21 10 0 3.14-1.05 6.04-2.8 8.37z",
    fill: "#00325a"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m54 21v22c0 .55-.45 1-1 1h-42c-.55 0-1-.45-1-1v-22c0-.55.45-1 1-1h42c.55 0 1 .45 1 1z",
    fill: "#fab400"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m60 47c0 1.38-.56 2.63-1.46 3.54-.91.9-2.16 1.46-3.54 1.46h-46c-2.76 0-5-2.24-5-5 0-.55.45-1 1-1h54c.55 0 1 .45 1 1z",
    fill: "#00a0c8"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m55.41 50.41c-.78.79-2.04.79-2.82 0l-4.41-4.41h5.64l1.59 1.59c.79.78.79 2.04 0 2.82z",
    fill: "#0082aa"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m37 48h-10c-.552 0-1-.448-1-1v-1h12v1c0 .552-.448 1-1 1z",
    fill: "#0082aa"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m53 20c-17.768 0-21.619 0-42 0-.55 0-1 .45-1 1v1c0-.55.45-1 1-1h8.357c-.869 1.82-1.357 3.852-1.357 6 0 7.73 6.27 14 14 14 3.51 0 6.7-1.3 9.16-3.43l2.32 2.33c-.38.39-.38 1.02.01 1.41l2.69 2.69h5.64l-5.51-5.51c-.39-.39-1.02-.39-1.41-.01l-2.33-2.32c2.13-2.46 3.43-5.65 3.43-9.16 0-2.148-.488-4.18-1.357-6h8.357c.55 0 1 .45 1 1v-1c0-.55-.45-1-1-1z",
    fill: "#dc9600"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m17 36h-4c-.552 0-1-.448-1-1 0-.552.448-1 1-1h4c.552 0 1 .448 1 1 0 .552-.448 1-1 1z",
    fill: "#f0f0f0"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m17 40h-4c-.552 0-1-.448-1-1 0-.552.448-1 1-1h4c.552 0 1 .448 1 1 0 .552-.448 1-1 1z",
    fill: "#f0f0f0"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m41.996 32.757h2.008v8.485h-2.008z",
    fill: "#00325a",
    transform: "matrix(.707 -.707 .707 .707 -13.569 41.241)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m43.03 35.61c-.41.53-.86 1.03-1.35 1.49l-2.39-2.39 1.42-1.42z",
    fill: "#00143c"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 26,
    fill: "#c8094f",
    r: 14
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 26,
    fill: "#f0f0f0",
    r: 12
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m44 26c0 .17 0 .33-.02.5-.25-6.4-5.52-11.5-11.98-11.5s-11.73 5.1-11.98 11.5c-.02-.17-.02-.33-.02-.5 0-6.63 5.37-12 12-12s12 5.37 12 12z",
    fill: "#d2d2d2"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m39 29.914h-1v-3h1c.552 0 1-.448 1-1s-.448-1-1-1h-1v-1c0-.55-.45-1-1-1h-1c0-.74-.215-1.425-.566-2.02l1.101-1.101c.391-.391.391-1.024 0-1.414-.391-.391-1.024-.391-1.414 0l-1.101 1.101c-1.252-.738-2.734-.77-4.04 0l-1.101-1.101c-.391-.391-1.024-.391-1.414 0-.391.391-.391 1.024 0 1.414l1.101 1.101c-.351.595-.566 1.28-.566 2.02h-1c-.55 0-1 .45-1 1v1h-1c-.552 0-1 .448-1 1s.448 1 1 1h1v3h-1c-.552 0-1 .448-1 1s.448 1 1 1h1.348c.825 2.332 3.045 4 5.652 4 2.459 0 4.788-1.558 5.652-4h1.348c.552 0 1-.448 1-1s-.448-1-1-1z",
    fill: "#d2d2d2"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m55.41 49.41c-.78.79-2.04.79-2.82 0l-9.103-9.103c-.391-.391-.391-1.024 0-1.414l1.406-1.406c.391-.391 1.024-.391 1.414 0l9.103 9.103c.79.78.79 2.04 0 2.82z",
    fill: "#c8094f"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m32.293 21.621c-.391-.391-.391-1.024 0-1.414l2.828-2.828c.391-.391 1.024-.391 1.414 0 .391.391.391 1.024 0 1.414l-2.828 2.828c-.39.391-1.024.391-1.414 0z",
    fill: "#00a0c8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m27.464 17.379c-.391.391-.391 1.024 0 1.414l2.828 2.828c.391.391 1.024.391 1.414 0 .391-.391.391-1.024 0-1.414l-2.828-2.828c-.39-.391-1.023-.391-1.414 0z",
    fill: "#00a0c8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m36 23.914h-8v-2c0-2.209 1.791-4 4-4 2.209 0 4 1.791 4 4z",
    fill: "#00325a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m30 25.914h-5c-.552 0-1-.448-1-1 0-.552.448-1 1-1h5z",
    fill: "#00325a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m30 30.914h-5c-.552 0-1-.448-1-1 0-.552.448-1 1-1h5z",
    fill: "#00325a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m39 25.914h-5v-2h5c.552 0 1 .448 1 1 0 .552-.448 1-1 1z",
    fill: "#00325a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m39 30.914h-5v-2h5c.552 0 1 .448 1 1 0 .552-.448 1-1 1z",
    fill: "#00325a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m38 22.914v6c0 3.359-2.739 6-6 6-3.307 0-6-2.678-6-6v-6c0-.55.45-1 1-1h10c.55 0 1 .45 1 1z",
    fill: "#00a0c8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m33 21.914v12.91c-.32.06-.66.09-1 .09s-.68-.03-1-.09v-12.91z",
    fill: "#0082aa"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebug);
export default __webpack_public_path__ + "static/media/debug.74126e42.svg";
export { ForwardRef as ReactComponent };